/**
 * @generated SignedSource<<0ef108bc27d4820650e1346e8894df8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody_rules" | "TableBody_rules">;
  readonly " $fragmentType": "IssueTable_rules";
};
export type IssueTable_rules$key = {
  readonly " $data"?: IssueTable_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTable_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "GroupTableBody_rules"
    },
    {
      "kind": "FragmentSpread",
      "name": "TableBody_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "d1ada0c226e54cad77408668ddb89aab";

export default node;
